import React from 'react'
import { IPageRenderConfig } from '@fareye/types'
import { RenderControl } from '@fareye/ui'
import { IMapper, useMapper } from '@fareye/common'
import { Hubs } from './hubs/Hubs'
import version from './../config/npmVersions'

export const HubsMapper = function(props: IMapper) {
  const [apiData, _] = useMapper({ ...props, version })
  return (
    <RenderControl state={apiData}>
      <Hubs {...props} config={apiData.data as IPageRenderConfig} />
    </RenderControl>
  )
}
